import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (e2) {
      setError(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 p-10">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-overline text-slate-500 hover:text-slate-900 mb-6"
        >
          <ArrowLeft size={12} strokeWidth={1.5} />
          Zurück zur Anmeldung
        </Link>

        <div className="text-xs font-bold uppercase tracking-overline text-slate-500">Passwort vergessen</div>
        <h1 className="font-heading text-4xl font-light tracking-tighter text-slate-900 mt-2">
          Reset-Link anfordern.
        </h1>

        {submitted ? (
          <div className="mt-8 border-l-2 border-blue-700 pl-4 py-1" data-testid="forgot-success">
            <p className="text-sm text-slate-700 leading-relaxed">
              Falls die E-Mail existiert, wurde ein Reset-Link erstellt. Prüfe dein Postfach (oder die
              Server-Logs in der Entwicklungsumgebung).
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-6" data-testid="forgot-form">
            <p className="text-sm text-slate-500">
              Gib deine E-Mail ein, wir senden dir einen Link zum Zurücksetzen.
            </p>
            <div>
              <label className="text-xs font-bold uppercase tracking-overline text-slate-500 mb-2 block">
                E-Mail
              </label>
              <input
                data-testid="forgot-email-input"
                type="email"
                className="input-tech"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            {error && (
              <div data-testid="forgot-error" className="text-sm text-red-600 border-l-2 border-red-600 pl-3 py-1">
                {error}
              </div>
            )}
            <button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={loading}
              className="w-full bg-slate-900 text-white py-4 text-sm font-medium hover:bg-slate-800 transition-colors disabled:opacity-50"
            >
              {loading ? "Wird gesendet…" : "Reset-Link senden"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
